import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TariffSelectionCardData } from '@mwe/models';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'mwe-tariff-card-router',
  templateUrl: './tariff-card-router.component.html',
  imports: [BasicCardComponent, TranslateDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TariffCardRouterComponent {
  tariff = input.required<TariffSelectionCardData>();
  routerName = computed(() => this.tariff().priceIndication?.internet?.router?.bezeichnung);
  routerPrice = computed(() => this.tariff().priceIndication?.internet?.router?.preisGeraet + ' EUR');
}
